import Header from '../../../../components/header';
import AboutContent from '../../../../module/profile/about';

const About = () => {
  return (
    <>
      <Header title={'درباره اپ تامین کننده'} />
      <AboutContent />
    </>
  );
};

export default About;
